module.exports = __webpack_public_path__ + "static/media/tournaments-feature.cd2cc668.svg";